import { TxtAttach } from "../core/index.model";
export class PageContent {
    public ScreenID: number;
    public ScreenName: string;
    public Content: Content[];
    public ScreenList: TxtScreenConfig[];
}

export class Content {
    public TxtTypeID: string;
    public LanguageType: string;
    public ControlName: string;
    public ControlDescription?: string;
    public DefaultText?: string;
    public CustomText?: string;
    public IsEnabled?: number;
    public IsMainPage: boolean;
    public IsTxtLanEnabled?: number;
}

export class TxtScreenConfig {
    public ScreenID: number;
    public ScreenName: string;
    public CustomJobName: string;
    public JurisID: number;
    public IsEnabled: boolean;
    public IsMainPage: boolean;
    public URL: string;
    public RecType: number;
    public MenuType?: string;    
    public FormType: string;
    public TxtAttach: TxtAttach[];
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/pagecontent.model.ts